import { render, staticRenderFns } from "./AnalisisPresupuesto.vue?vue&type=template&id=b2c2772c&scoped=true&"
import script from "./AnalisisPresupuesto.vue?vue&type=script&lang=js&"
export * from "./AnalisisPresupuesto.vue?vue&type=script&lang=js&"
import style0 from "./AnalisisPresupuesto.vue?vue&type=style&index=0&id=b2c2772c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c2772c",
  null
  
)

export default component.exports